export const initialState = {
  isOpened: false,
  actionProcessing: false,
  tableType: null,
  rows: [],
  columns: [],
  parsedMessage: '',
};
